import { render, staticRenderFns } from "./VoucherList.vue?vue&type=template&id=60a3b637&"
import script from "./VoucherList.vue?vue&type=script&lang=js&"
export * from "./VoucherList.vue?vue&type=script&lang=js&"
import style0 from "./VoucherList.vue?vue&type=style&index=0&id=60a3b637&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports